import { useState, useLayoutEffect } from 'react'

const useWindowSize = () => {
    const [width, setWidth] = useState(window.innerWidth)
    const [height, setHeight] = useState(window.innerHeight)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1194)

    useLayoutEffect(() => {
        const updateSize = () => {
            setWidth(window.innerWidth)
            setHeight(window.innerHeight)
            setIsMobile(window.innerWidth < 768)
            setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1194)
        }
        window.addEventListener('resize', updateSize)
        return () => {
            window.removeEventListener('resize', updateSize)
        }
    }, [])

    return { width, height, isMobile, isTablet }
}

export default useWindowSize
